/**
 * Section partners component
 * 
 */

import React, { PureComponent } from 'react';

// Components

import Partners from '../partners/partners';

export default class SectionPartners extends PureComponent {

	render() {
		
		const { data, items } = this.props;
			
		return (
			
	        <div className="section section-catchline text-center">
                <div className="container">
                    
                    { !! data.title && <h3>{data.title}</h3> }
                    <Partners items={items}></Partners>

                </div>
            </div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/sections/section-partners.js